
import { Vue, Component, Ref } from 'vue-property-decorator';
import lazyInject from '@/di';
import SupplyService from '@/services/supply.service';
import ImagePreviewModal from '@/views/supplyChain/platform/components/ImagePreviewModal.vue';

@Component({
  components: {
    ImagePreviewModal,
  },
})
export default class PurchaseOrderDetailModal extends Vue {
  visible = false;

  @lazyInject(SupplyService)
  supplyService!: SupplyService;

  @Ref('imagePreviewModal')
  imagePreviewModal!: ImagePreviewModal;

  detail: any = {};

  productList: any[] = [];

  currentOrderNo = '';

  pagination: any = {
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    showTotal: () => `共${this.pagination.total}条`,
    onChange: this.paginationChange,
    onShowSizeChange: this.onShowSizeChange,
  };

  paymentStatusMap: any = {
    0: '未付款',
    1: '已付款',
  };

  logisticsStatusMap: any = {
    0: '未发货',
    1: '已发货',
  };

  invoiceStatusMap: any = {
    0: '未开票',
    1: '已开票',
  };

  productColumns = [
    {
      title: '物料编号',
      dataIndex: 'commodity_code',
      align: 'center',
    },
    {
      title: '产品名称',
      dataIndex: 'commodity_name',
      align: 'center',
    },
    {
      title: '规格',
      dataIndex: 'specification',
      align: 'center',
      scopedSlots: { customRender: 'specification' },
    },
    {
      title: '数量/箱',
      dataIndex: 'quantityPerBox',
      align: 'center',
      scopedSlots: { customRender: 'quantityPerBox' },
    },
    {
      title: '下单箱数',
      dataIndex: 'package_quantity',
      align: 'center',
    },
    {
      title: '下单壶数',
      dataIndex: 'orderPots',
      align: 'center',
      scopedSlots: { customRender: 'orderPots' },
    },
    {
      title: '单价/壶',
      dataIndex: 'agent_price',
      align: 'center',
    },
    {
      title: '小计（元）',
      dataIndex: 'amount',
      align: 'center',
      scopedSlots: { customRender: 'subtotal' },
    },
  ];

async open(record: any) {
    this.detail = record ? { ...record } : {};
    this.visible = true;
    this.getDetail(record);
    this.currentOrderNo = record.orderNo;
    this.pagination.current = 1;
    this.pagination.total = 0;
    this.detailByOrder();
  }

  async getDetail(val: any) {
    const res = await this.supplyService.getDistributorPurchaseOrderDetail(
      val.orderNo,
    );
    if (res) {
      this.detail = res;
    }
  }

  async detailByOrder() {
    const params: any = {
      order_no: this.currentOrderNo,
      page: this.pagination.current,
      pageSize: this.pagination.pageSize,
    };
    const res = await this.supplyService.getCommodityDetailByOrder(params);
    if (res) {
      this.productList = res.list || [];
      this.pagination.total = res.total || 0;
    }
  }

  paginationChange(page: number, pageSize: number) {
    this.pagination.current = page;
    this.pagination.pageSize = pageSize;
    this.detailByOrder();
  }

  onShowSizeChange(current: number, pageSize: number) {
    this.pagination.current = current;
    this.pagination.pageSize = pageSize;
    this.detailByOrder();
  }

  viewReceiptVoucher() {
    const list = this.detail.voucher_url.map((item: any) => item.url);
    this.imagePreviewModal.open('付款单', list || []);
  }

  viewDeliveryOrder(value: any) {
    console.log(value);
    const urls = value.sign_resource ? value.sign_resource.map((item: any) => item.url) : [];
    this.imagePreviewModal.open('发货单', urls || []);
  }

  onClose() {
    this.visible = false;
    this.detail = {};
    this.productList = [];
    this.currentOrderNo = '';
    this.pagination.current = 1;
    this.pagination.pageSize = 10;
    this.pagination.total = 0;
  }
}
